import { useTheme } from 'styled-components'
import Typography from '../../../Typography'
import { Flex } from '../../../StyledComponents';

interface ComponentProps {
  value: string;
  totalZaps?: number;
}

const Component = ({ value, totalZaps = 3 }: ComponentProps) => {
  const theme = useTheme() as { [key: string]: { [key: string]: string } }
  const difficulty = ['Principiante', 'Intermedio', 'Avanzado', 'Deluxe']

  return (
    <Flex align="center" gap={10}>
      <Typography as="p" size="xs">Complejidad {value}</Typography>
    </Flex>
  )
};

export default Component;
